(ns quuppa.qsm.core
  (:require [quuppa.qsm.permissions :as permissions]
            [reitit.frontend.easy :as rfe]
            [re-frame.core :as rf]
            ["react" :as react]
            [reagent.dom :as rdom]
            [shadow.loader :as loader]
            [quuppa.peweb.http :as http]
            [quuppa.qsm.routing :as routing]
            [quuppa.qsm.events]
            [quuppa.components :as components]
            [quuppa.peweb.connection :as connection]
            [quuppa.peweb.notifications :as notifications]
            [quuppa.peweb.confirm :as confirm]
            [quuppa.qsm.signin.view :as signin]
            [quuppa.qsm.view :as view]
            ;; We want to handle all WS events even if mapview UI module isn't yet loaded.
            quuppa.peweb.mapview-events
            ;; Register compare/equiv etc. protocol implementations for js-joda classes.
            quuppa.date
            [quuppa.frontend-utils :refer [hide-react-duplicate-errors!]]
            [quuppa.error-reporting :as error-reporting])
  (:require-macros [quuppa.common.version :as version]))

(def default-db
  {;;this will show qpe-info-ui where calling from. e.g. :qsm, qpe
   :app-id            :qsm
   :is-qsm-owner? (permissions/is-qsm-owner?)})

(rf/reg-event-db
  ::init-db
  (fn [db _]
    (merge default-db db)))

(defn ui-root []
  (let [view-f @(rf/subscribe [:nav/match :data :view])
        session @(rf/subscribe [:user/session])
        navbar-content-ref (react/useRef)]
    [:r> (.-Provider view/MainContext)
     ;; NOTE: On initial render (of view-f render), navbar-content-ref is stil still nil,
     ;; because navbar hasn't been rendered yet. This means the navbar-content using portal
     ;; through the ref doesn't work (no error, just doesn't render anything).
     ;; There isn't an easy way to trigger first view-f render only after
     ;; the ref has been set, because the ref value change by design doesn't trigger render.
     ;; The problem is only visible on dev, when changing this namespace. Modifying breadcrumb use
     ;; ns again brings the breadcrumb visible again.

     ;; Value is clojure map. :r> keeps the types.
     #js {:value {:navbar-content-ref navbar-content-ref}}
     (when (and (not (:pending session))
                (some? (:user session)))
       [connection/connection-status])
     [notifications/render-notifications]
     (when (false? (:pending session))
       (if (:user session)
         [view/root
          (if view-f
            [:main.d-flex [view-f]]
            [:div.p-4 "Missing view"])]
         [signin/signin-page]))
     [confirm/render-confirm]]))

(defn ^:dev/after-load mount-components []
  (rf/clear-subscription-cache!)
  (rfe/start! routing/routes
              (fn [match]
                (rf/dispatch [:nav/navigated match]))
              {:use-fragment true})
  (rdom/render
    [components/error-boundary
     [:f> ui-root]]
    (.getElementById js/document "app")))

(defn init! []
  (rf/dispatch-sync [::init-db])
  (http/configure-http-fx!)
  (mount-components)
  (rf/dispatch [:user/get-user
                {:on-success [::connection/initialize
                              {:on-open [:nav/enable-controllers]
                               ;; Re-run controllers to register subs again.
                               :on-reconnect [:nav/reset-controllers]}]}]))

;; Load reagent-dev-tools on localhost or manually from console.
(defn enable-dev-tools []
  (when (or (= "localhost" (.. js/document -location -hostname))
            (.getItem js/localStorage (pr-str ::devtools)))
    (loader/load "devtools")))

(defn ^:export enable-dev-tools! []
  (.setItem js/localStorage (pr-str ::devtools) "1")
  (enable-dev-tools))

(.addEventListener js/window "load" (fn [] (enable-dev-tools)))

(println "version" (version/get-version-info))

(hide-react-duplicate-errors!)

(error-reporting/enable-error-reporting!)
